import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseAddStaffFailureAlertRecipientMutationVariables = {
  email: string;
};

export const useAddStaffFailureAlertRecipientMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email }: UseAddStaffFailureAlertRecipientMutationVariables) => {
      const { data } = await authApi.post<{ staffFailureAlertRecipients: string[] }>(
        "/staff/staff-failure-alert-recipients",
        { email }
      );
      return data.staffFailureAlertRecipients;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["staff-failure-alert-recipients"],
      });
    },
  });
};
